import { apiGet } from "@/lib/api";
import { LIVE_LIST } from "@/lib/query-freshness";
import type { NavCountsResponse } from "@/types-nav-counts";

/**
 * How often the sidebar reads its counts again while the console is open. It also reads them on
 * focus and right after any console write (`lib/query-client.ts`), and upstream never caches them,
 * so a finished task leaves its badge at once.
 */
export const NAV_COUNTS_REFRESH_MS = 60_000;

/** One read for every area's badge; each badge `select`s its own key. */
export function navCountsQuery() {
  return {
    ...LIVE_LIST,
    refetchInterval: NAV_COUNTS_REFRESH_MS,
    queryKey: ["nav-counts"] as const,
    queryFn: () => apiGet<NavCountsResponse>("/api/admin/nav-counts"),
  };
}
